__turbopack_context__.v({
  "label": "FinanceSummaryRow-module__ZsXJnW__label",
  "summaryItem": "FinanceSummaryRow-module__ZsXJnW__summaryItem",
  "summaryRow": "FinanceSummaryRow-module__ZsXJnW__summaryRow",
  "value": "FinanceSummaryRow-module__ZsXJnW__value",
});
